export default {
  home: {
    text: 'Home',
    icon: 'home',
    href: '/',
  },
  trinkets: {
    text: 'Trinkets',
    icon: 'dashboard',
    href: '/trinkets',
  },
  blog: {
    text: 'Blog',
    icon: 'library_books',
    href: '/blog',
  },
  classProject: {
    text: 'Class Project',
    icon: '',
    href: '/projects/class-project',
  },
  hackAThon: {
    text: 'Hack-A-Thon',
    icon: '',
    href: '/projects/hack-a-thon',
  },
  demoDay: {
    text: 'Demo Day',
    icon: '',
    href: '/projects/demo-day',
  },
};
